<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tiposCert">
    <fieldset id="agregar_tiposCert" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">

                    <div class="form-horizontal titulo">
                        <div class="form-group" align="left">
                            <div class="col-md-12">
                                <h4>
                                    <label for="tipocert">Certificados:</label>
                                </h4>
                            </div>
                        </div>
                        <div>
                        </div>

                    </div>


                </div>
            </div>
        </div>
    </fieldset>
</div>

<mat-accordion>
    <mat-expansion-panel *ngFor="let prop of propiedades; let x = index">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <p>ROL</p>
            </mat-panel-title>
            <mat-panel-description>
                {{prop.rol}}
            </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-radio-group>
            <mat-checkbox *ngFor="let certificado of listaFinal" class="example-margin" [value]="certificado.cert_id" (click)="addCertificado(prop, certificado)">{{certificado.tipo}}</mat-checkbox>

        </mat-radio-group>
    </mat-expansion-panel>
</mat-accordion>
<div class="separator"></div>